import React, { ReactElement } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { DataProduct } from 'v2/models';
import styles from './DataProductItem.module.scss';
import { formatDate } from 'v2/utils/dateUtils';

interface DataProductItemProps {
  dataProduct: DataProduct;
  onClick: (dataProduct: DataProduct) => void;
  isSelected: boolean;
  actions?: ReactElement;
}

const DataProductItem = ({
  dataProduct,
  onClick,
  isSelected,
  actions,
}: DataProductItemProps) => {
  const dataProductPurchases = dataProduct?.purchases || [];
  const isRenewalDateAfterMoment =
    dataProductPurchases.length > 0 &&
    moment(dataProductPurchases[0].renewal_date).isAfter(moment(), 'day');

  return (
    <div
      onClick={() => onClick(dataProduct)}
      className={classnames(styles.item, { [styles.itemSelected]: isSelected })}
      aria-label="data-product-button"
      aria-selected={isSelected}
    >
      <div className={classnames(styles.itemContainer)}>
        <p className={classnames(styles.dataProductName)}>{dataProduct.name}</p>
        <p
          className={classnames(styles.dataProductDate)}
          data-testid={`renewal-date__${dataProduct.id}`}
        >
          {isRenewalDateAfterMoment && dataProductPurchases[0].renewal_date
            ? formatDate(dataProductPurchases[0].renewal_date, false)
            : null}
        </p>
        {actions}
      </div>
    </div>
  );
};

export default DataProductItem;
